// Analytics helpers shared across pages.
// Keep dependency-free so it can be imported anywhere (incl. server routes).

export function newInterviewId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // Fallback for older runtimes.
  return `iv_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
}

// Buckets free-text errors into low-cardinality categories so PostHog
// breakdowns stay usable. Keep raw message in a separate `error_message` prop
// (truncated) if you want the detail.
export function classifyError(e: unknown): string {
  const s = e instanceof Error ? `${e.name}:${e.message}` : String(e ?? '')
  const lower = s.toLowerCase()
  if (lower.includes('aborterror') || lower.includes('aborted')) return 'aborted'
  if (lower.includes('timeout') || lower.includes('timed out')) return 'timeout'
  if (lower.includes('429') || lower.includes('rate limit') || lower.includes('quota')) return 'rate_limit'
  if (lower.includes('401') || lower.includes('unauthor')) return 'unauthorized'
  if (lower.includes('403') || lower.includes('forbidden')) return 'forbidden'
  if (lower.includes('404')) return 'not_found'
  if (lower.includes('5') && (lower.includes('500') || lower.includes('502') || lower.includes('503') || lower.includes('504'))) return 'server_5xx'
  if (lower.includes('networkerror') || lower.includes('failed to fetch') || lower.includes('econnreset')) return 'network'
  if (lower.includes('json') || lower.includes('parse')) return 'parse'
  if (lower.includes('permission')) return 'permission_denied'
  return 'unknown'
}

export function truncErrorMessage(e: unknown, max = 200): string {
  const s = e instanceof Error ? e.message : String(e ?? '')
  return s.length > max ? s.slice(0, max) : s
}
